import React, { Fragment } from "react";
import { utils } from '../common/utils';
import ConfirmDialog from "../components/ConfirmDialog";
import { withTranslation } from 'react-i18next';
import { showSuccess, showError } from "../common/iziToast";
import * as Icons from "../common/icons";
import { SHARE_BY_EMAIL_URL} from "../common/urls";
import axios from "axios";
import { isVlidEmail } from '../common/validators';

class SocialShare extends React.Component {
    constructor(props) {
        super(props);
        this.state = { urlToShare: '', openEmailDialog: false, receiverEmail: "", receiverName: "", message: "", invalidEmail: false };

        this.onInputchange = this.onInputchange.bind(this);
        this.onCopyLink = this.onCopyLink.bind(this);
        this.onShareByEmail = this.onShareByEmail.bind(this);
        
    }
    componentDidMount() {
        const { url } = this.props;
        this.setState({
            urlToShare: (url ? url : window.location.origin)
        });
    }

    onInputchange(event) {
        this.setState({
            [event.target.name]: event.target.value
        });
    }
    onShareByEmail() {
        this.setState({ openEmailDialog: true });
    }

    onCancelShareByEmail() {
        this.setState({ openEmailDialog: false });
    }
    
    triggerShareByEmail() {
        const { urlToShare, receiverEmail, receiverName, message } = this.state;
        if (isVlidEmail(receiverEmail) === false) {
            this.setState({
                invalidEmail: true
            });

            return false; // disable dialog from closing
        }

        const { senderName, supplierName, t } = this.props;
        const sendOptions = { senderName: (senderName ? senderName : supplierName), receiverName: receiverName, receiverEmail: receiverEmail, url: urlToShare, message: message };

        axios.post(SHARE_BY_EMAIL_URL, sendOptions).then((response) => {
            if (response.status === 200 && response.data === true) {
                this.setState({ openEmailDialog: false, receiverEmail: "", receiverName: "", message: "", invalidEmail: false });
                showSuccess(t("Share by email"), `${t("Shared successfuly")}`, Icons.EMAIL);
            } else {
                showError(t("Share by email"), `${t("Unable to share by email. please try again later")}`, Icons.EMAIL);
            }
          
        }, (error) => {
            showError(t("Share by email"), `${t("Unable to share by email. please try again later")}`, Icons.EMAIL);
        });
    }

    onCopyLink() {
        const { urlToShare } = this.state;
        const { t } = this.props;
        utils.copyTextToClipboard(urlToShare);
        showSuccess(t("Copy"), `${t("Link copied successfuly")}`, Icons.COPY);
    }

    render() {

        const { shape, showTitle, displayInline, supplierName, t, shareTitle } = this.props;
        const { urlToShare, invalidEmail } = this.state;

        const shareLinks = (
            <Fragment>
                <ConfirmDialog title={t("Share by email")} open={this.state.openEmailDialog} message="" yesTitle={t("Share")} onYes={this.triggerShareByEmail.bind(this)} noTitle={t("Cancel")} onNo={this.onCancelShareByEmail.bind(this)} >
                    <div className="form-group">
                        <label className='p-0'>{t('Receiver Name')}</label>
                        <input className="form-control form-control-rounded min-input-width " name="receiverName" type="text" placeholder='' value={this.state.receiverName} onChange={this.onInputchange} />
                    </div>
                    <div className="form-group">
                        <label className='p-0'>{t('Receiver Email')}</label> {invalidEmail && <label className='p-0 red'>{t("Invalid Email")}</label>}
                        <input className={"form-control form-control-rounded min-input-width" + (invalidEmail ? " has-error" : "")} name="receiverEmail" type="text" placeholder={t('ShareEmailDesc')} value={this.state.receiverEmail} onChange={this.onInputchange} />
                    </div>
                    <div className="form-group">
                        <label className='p-0'>{t('Message')}</label>
                        <textarea className="form-control form-control-rounded min-input-width " name="message" rows="4" type="text" placeholder='' value={this.state.message} onChange={this.onInputchange} />
                    </div>
                </ConfirmDialog>

                <a  className={`social-button shape-${shape} sb-facebook sb-dark`}
                    href={`https://www.facebook.com/sharer/sharer.php?u=${urlToShare}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Facebook"
                >
                    <i className="socicon-facebook" />
                </a>
                <a  className={`social-button shape-${shape} sb-twitter sb-dark`}
                    href={`https://twitter.com/intent/tweet?url=${urlToShare}&text=${shareTitle}&via=${supplierName}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Twitter"
                >
                    <i className="socicon-twitter" />
                </a>
                {/*Google plus is not available anymore*/}
                {/*<a*/}
                {/*    className={`social-button shape-${shape} sb-google-plus sb-dark`}*/}
                {/*    href={`https://plus.google.com/share?url=${urlToShare}`}*/}
                {/*    target="_blank"*/}
                {/*    rel="noopener noreferrer"*/}
                {/*    data-toggle="tooltip"*/}
                {/*    data-placement="top"*/}
                {/*    title="Google +"*/}
                {/*>*/}
                {/*    <i className="socicon-googleplus" />*/}
                {/*</a>*/}
                <a  className={`social-button sb-pinterest shape-${shape} sb-dark`}
                    href={`http://pinterest.com/pin/create/button?url=${urlToShare}`} //&description=This+page+is+really+cool&media=URL of image to pin
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <i className="socicon-pinterest" />
                </a>

                <a  className={`social-button sb-mail shape-${shape} sb-dark`}
                     onClick={this.onShareByEmail}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <i className="socicon-mail" />
                </a>

                <a  className={`social-button sb-copy shape-${shape} sb-dark`}
                     onClick={this.onCopyLink}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <i className="pe-7s-copy-file copy-icon" />
                </a>

            </Fragment>
        );

        return showTitle ? (
            <div className={`entry-share mt-2 mb-2 ${(displayInline ? 'd-inline' : '')}`}>
                <span className="text-muted">{t("Share")}:</span>
                <div className="share-links">{shareLinks}</div>
            </div>
        ) : (
            <Fragment>{shareLinks}</Fragment>
        );
    }
}

export default withTranslation()(SocialShare);

